export default __webpack_public_path__ + "static/media/06-extreme-users.4092da93.png";